import React, { useRef, useState, useEffect, useContext  } from "react";
import * as S from "./FlorenzInput.style.js";
import * as P from "../../../utils/pipes.js";
import { ThemeContext } from 'styled-components';
import { useTranslation } from "react-i18next";

function  FlorenzInput({ 
  placeholder, 
  icon,
  value,
  getText,
  type,
  disabled
}) {  
  const { t, i18n: { language } } = useTranslation("global");  
  const container = useRef(null);
  const textInput = useRef(null);
  const [active, setActive] = useState(false);

  useEffect(() => {
    const handleClickOutside = e => {
      if (!container.current.contains(e.target)) {
        setActive(false)
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  const activeInput = () => {    
    if (!disabled) {
      textInput.current.focus(); 
      setActive(true);
    } 
  } 

  return (
    <S.FlorenzInput
      active={active} 
      disabled={disabled} 
    >
        <div className="input-container" onClick={() => activeInput()} ref={container}>
          {
            icon && <i className={'icon-input-form icon zaia-' + icon} />
          }      
          {
            type === "number" &&
            <div className="numeral">#</div>
          }    
          <input 
            ref={textInput}
            type={type || "text"}
            placeholder={disabled ? t("globally.answer") : placeholder} 
            onChange={(event) => {              
              if(type === "number" && event.target.value === "" ) {
                getText("")
              } else {
                getText(event.target.value)
              }
            }}
            value={value === 0 ? "" : value}
            onWheel={(e) => e.target.blur()}
            onKeyDown={(e) => {
              if (e.key === "ArrowUp" || e.key === "ArrowDown") {
                e.preventDefault();
              }
            }}
            disabled={disabled}
          />     
  {
            disabled &&
            <i className="icon-disabled icon zaia-i-lock-chat"></i>
          }  
        </div>
    </S.FlorenzInput>
  );
}

export default FlorenzInput;
